export default __webpack_public_path__ + "static/media/icon_event_admin_outline.06339f88.svg";